import React, { ReactElement } from 'react';
import {
  Button, Col, Row, StepperIdsk, StepperIdskItem, Tag,
} from 'idsk-react-components';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import StadiumMaterialuHistoriaList from '../../../model/legislativnyMaterial/StadiumMaterialuHistoriaList';
import LegislativnyMaterialDetailRow
  from '../LegislativnyMaterialDetail/component/LegislativnyMaterialBasicData/component/LegislativnyMaterialDetailRow';
import mapDate from '../../../function/mapDate';
import './legislativnyMaterialHistoria.scss';
import VlastnyMaterialButton from './component/VlastnyMaterialButton';
import LegislativnyMaterialDetailType from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import getSprievodnyDokumentRoute from '../../../function/sprievodnyDokumentRoute';
import { StadiumMaterialuEnum } from '../../../model/legislativnyMaterial/StadiumMaterialu';
import StadiumMaterialuHistoria from '../../../model/legislativnyMaterial/StadiumMaterialuHistoria';
import Organizacia from '../../../model/ciselniky/Organizacia';
import { canShowNonPublicData } from '../../../function/permissions';
import { useUserContext } from '../../../context/UserContext';
import { currentStadiumEqualsLatest } from '../../../function/getLatestStadium';

interface Props {
  materialDetail: LegislativnyMaterialDetailType;
  legMaterialHistoriaList: StadiumMaterialuHistoriaList;
}

const LegislativnyMaterialHistoria = ({
  materialDetail,
  legMaterialHistoriaList,
}: Props): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();
  const { pouzivatel } = useUserContext();
  const navigate = useNavigate();

  const isLatestStadium = (stadiumHistoriaIndex: number)
    : boolean => stadiumHistoriaIndex === legMaterialHistoriaList.historiaRecords.length - 1;

  const historiaRecord = (
    stadium: StadiumMaterialuHistoria,
    stadiumIndex: number,
    vlastnikAktivity: Organizacia,
  ): ReactElement => (
    <StepperIdskItem
      key={stadium.uuid}
      heading={(
        <div>
          <div className="idsk-stepper__section-heading">{stadium.stadium?.nazov}</div>
          {stadium.datumUkoncenia ? null : <Tag type="primary">PREBIEHA</Tag>}
        </div>
      )}
    >
      <div className="idsk-stepper__links">
        {!stadium.datumUkoncenia && (
          <VlastnyMaterialButton
            legMaterialUuid={materialDetail?.uuid}
            stadiumUuid={stadium.uuid}
            type={type}
          />
        )}
        <Button
          className="idsk-stepper__link"
          onClick={() => navigate(getSprievodnyDokumentRoute(
            pouzivatel,
            materialDetail?.hasOpravnenieSprievodneDokumenty,
            currentStadiumEqualsLatest(materialDetail?.stadium?.hodnota, legMaterialHistoriaList?.historiaRecords),
            isLatestStadium(stadiumIndex),
            stadium?.uuid,
            type,
            year,
            index,
          ))}
          buttonStyle="link"
          size="small"
        >
          Sprievodné dokumenty
        </Button>
      </div>
      <LegislativnyMaterialDetailRow
        firsColumnSize="one-quarter"
        header="Začiatok štádia"
        data={mapDate(stadium.datumZacatia)}
      />
      <LegislativnyMaterialDetailRow
        firsColumnSize="one-quarter"
        header="Ukončenie štádia"
        data={mapDate(stadium.datumUkoncenia)}
      />
      <LegislativnyMaterialDetailRow
        firsColumnSize="one-quarter"
        header="Vlastník aktivity"
        data={vlastnikAktivity?.nazov
          ? `${vlastnikAktivity.skratenyNazov} (${vlastnikAktivity.nazov})` : null}
      />
    </StepperIdskItem>
  );

  const pripravaHistoriaRecord = (
    stadium: StadiumMaterialuHistoria,
    vlastnikAktivity: Organizacia,
  ): ReactElement => (
    <StepperIdskItem
      key={stadium.uuid}
      heading={(
        <div>
          <div className="idsk-stepper__section-heading">{stadium.stadium?.nazov}</div>
          {stadium.datumUkoncenia ? null : <Tag type="primary">PREBIEHA</Tag>}
        </div>
      )}
    >
      <LegislativnyMaterialDetailRow
        firsColumnSize="one-quarter"
        header="Vlastník aktivity"
        data={vlastnikAktivity?.nazov
          ? `${vlastnikAktivity.skratenyNazov} (${vlastnikAktivity.nazov})` : null}
      />
    </StepperIdskItem>
  );

  return (
    <Row className="slovlex-idsk-leg-material-historia">
      <Col widthDesktop="two-thirds">
        <StepperIdsk title="Štádiá procesu">
          {
            legMaterialHistoriaList.historiaRecords.map((stadium, stadiumIndex) => {
              const vlastnikAktivity = stadium.datumUkoncenia === null
                ? materialDetail.vlastnikAktivity : stadium.vlastnikAktivity;
              if (stadium.stadium.hodnota === StadiumMaterialuEnum.PRIPRAVA_MATERIALU
                && !canShowNonPublicData(pouzivatel, materialDetail)) {
                return pripravaHistoriaRecord(stadium, vlastnikAktivity);
              }
              return historiaRecord(stadium, stadiumIndex, vlastnikAktivity);
            })
          }
        </StepperIdsk>
      </Col>
    </Row>
  );
};

export default LegislativnyMaterialHistoria;
